import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router';
import type { TasProgramInstanceExtension as TasProgramInstanceModel } from 'tio-data/data/resources/tas-program-instance.ext';
import type { TasParticipantExtension as TasParticipantModel } from 'tio-data/data/resources/tas-participant.ext';

interface ProgramsRouteModel {
  programInstance: TasProgramInstanceModel;
  tasParticipant: TasParticipantModel;
}

export default class AuthenticatedTasProgramsShowRoute extends Route {
  @service declare router: RouterService;

  // No model hook needed - inherits from parent route
  // Parent route (authenticated/tas/programs.ts) handles the tas_program_instance_id parameter

  afterModel(model: ProgramsRouteModel) {
    // check if program is still in draft state - send to new program page
    if (model.programInstance.isDraft) {
      this.router.transitionTo('authenticated.tas.programs.new-guided', model.programInstance.id);
    }
  }
}
